// extracted by mini-css-extract-plugin
export var chip = "_m8-2";
export var chipBody = "_m8-8";
export var chipHeader = "_m8-9";
export var chipWithKind = "_m8-7";
export var icon = "_m8-3";
export var kind = "_m8-a";
export var remove = "_m8-5";
export var removeIcon = "_m8-6";
export var row = "_m8-0";
export var rowHistorical = "_m8-1";
export var text = "_m8-4";